// src/components/admin/AdminLogs.jsx
import React, { useEffect, useState } from "react";
import { useAdminApi } from "../../admin/adminApi";

const AdminLogs = () => {
  const { getJson } = useAdminApi();
  const [logs, setLogs] = useState([]);
  const [error, setError] = useState("");

  const load = async () => {
    try {
      setError("");
      const data = await getJson("/api/logs/recent?limit=100");
      setLogs(data.logs || []);
    } catch (e) {
      console.error("[ADMIN] Logs error:", e);
      setError("Failed to load logs");
    }
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 7000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      style={{
        borderRadius: 16,
        padding: 12,
        background:
          "linear-gradient(135deg, rgba(15,23,42,0.97), rgba(15,23,42,1))",
        border: "1px solid rgba(148,163,184,0.35)",
      }}
    >
      <div
        style={{
          fontSize: 13,
          fontWeight: 600,
          marginBottom: 8,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <span>Recent Events</span>
        <button
          onClick={load}
          style={{
            fontSize: 11,
            borderRadius: 999,
            border: "1px solid rgba(148,163,184,0.6)",
            padding: "2px 8px",
            background: "rgba(15,23,42,0.9)",
            color: "#e5e7eb",
            cursor: "pointer",
          }}
        >
          Refresh
        </button>
      </div>

      {error && (
        <div style={{ fontSize: 11, color: "#f97373" }}>{error}</div>
      )}

      {logs.length === 0 && !error && (
        <div style={{ fontSize: 12, color: "#9ca3af" }}>No logs yet.</div>
      )}

      {logs.length > 0 && (
        <div
          style={{
            maxHeight: 260,
            overflowY: "auto",
            fontSize: 11,
            fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas",
          }}
        >
          {logs
            .slice()
            .reverse()
            .map((log, idx) => (
              <div
                key={idx}
                style={{
                  padding: "4px 6px",
                  borderBottom: "1px solid rgba(31,41,55,0.9)",
                }}
              >
                <div style={{ color: "#9ca3af" }}>
                  {log.ts} ·{" "}
                  <span style={{ color: "#7dd3fc" }}>{log.type}</span>
                </div>
                {log.payload && (
                  <pre
                    style={{
                      margin: 0,
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      color: "#e5e7eb",
                    }}
                  >
                    {JSON.stringify(log.payload, null, 2)}
                  </pre>
                )}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default AdminLogs;
